import type { Path } from './types';

export default (thePath: Path): string => {
    if (typeof thePath === 'string') {
        return thePath;
    } else {
        return thePath.href;
    }
};
